'use client';

import dynamic from 'next/dynamic';

import type { UiAdvertisingInformerBaseProps } from './UiAdvertisingInformerBase';

export const UiAdvertisingInformerBase =
  dynamic<UiAdvertisingInformerBaseProps>(
    () =>
      import('./UiAdvertisingInformerBase').then(
        (mod) => mod.UiAdvertisingInformerBase
      ),
    { ssr: false }
  );
